import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web';
// const baseUrl = 'v1/erp-sale-web';
export default {
  axios,
  getFinanceProceedsListDownload(params) {
    return axios.get(`${baseUrl}/financeProceeds/list/download?${utils.exchangeParams(params)}`);
  },
  getFinanceVerifyListDownload(params) {
    return axios.get(`${baseUrl}/financeProceeds/proceeds/download?${utils.exchangeParams(params)}`);
  },

  getFinancePayableList(params) {
    return axios.get(`${baseUrl}/financePayable/list?${utils.exchangeParams(params)}`);
  },
  getFinancePayableSupplier(params) {
    return axios.get(`${baseUrl}/financePayable/listSupplierInfo?${utils.exchangeParams(params)}`);
  },
  getFinancePayableRefundSupplier(params) {
    return axios.get(`${baseUrl}/financePayable/listRefundSupplierInfo?${utils.exchangeParams(params)}`);
  },
  getFinancePaymentSupplier(params) {
    return axios.get(`${baseUrl}/financePayment/listSupplierInfo?${utils.exchangeParams(params)}`);
  },
  submitFinancePayable(params) {
    return axios.post(`${baseUrl}/financePayable/submit`, utils.exchangeParams(params));
  },
  editFinancePayable(params) {
    return axios.post(`${baseUrl}/financePayable/edit`, utils.exchangeParams(params));
  },
  addAndSubmitFinancePayable(params) {
    return axios.post(`${baseUrl}/financePayable/addAndSubmit`, utils.exchangeParams(params));
  },
  addFinancePayable(params) {
    return axios.post(`${baseUrl}/financePayable/add`, utils.exchangeParams(params));
  },
  getlistPayableInspectionInfos(params) {
    return axios.get(`${baseUrl}/purchaseInspection/listPayableInspectionInfos?${utils.exchangeParams(params)}`);
  },
  getlistPayableRefundInfos(params) {
    return axios.get(`${baseUrl}/purchaseRefund/listPayableRefundDetail?${utils.exchangeParams(params)}`);
  },
  getlistPayableRecallDetail(params) {
    return axios.post(`${baseUrl}/sale/recall/plan/listPayableRecallDetail`,utils.exchangeParams(params));
  },
  getlistUnRelatePayment(params) {
    return axios.get(`${baseUrl}/financePayable/listUnRelatePayment?${utils.exchangeParams(params)}`);
  },
  getFinancePayableDetail(params) {
    return axios.get(`${baseUrl}/financePayable/info?${utils.exchangeParams(params)}`);
  },
  financePayableDownload(params) {
    return axios.get(`${baseUrl}/financePayable/list/download?${utils.exchangeParams(params)}`);
  },
  getFinancePaymentList(params) {
    return axios.get(`${baseUrl}/financePayment/list?${utils.exchangeParams(params)}`);
  },
  submitFinancePayment(params) {
    return axios.post(`${baseUrl}/financePayment/submit`, utils.exchangeParams(params));
  },
  editFinancePayment(params) {
    return axios.post(`${baseUrl}/financePayment/edit`, utils.exchangeParams(params));
  },
  addAndSubmitFinancePayment(params) {
    return axios.post(`${baseUrl}/financePayment/addAndSubmit`, utils.exchangeParams(params));
  },
  addFinancePayment(params) {
    return axios.post(`${baseUrl}/financePayment/add`, utils.exchangeParams(params));
  },
  getlistPaymentInspectionInfos(params) {
    return axios.get(`${baseUrl}/purchaseInspection/listPayableInspectionInfos?${utils.exchangeParams(params)}`);
  },
  getFinancePaymentDetail(params) {
    return axios.get(`${baseUrl}/financePayment/info?${utils.exchangeParams(params)}`);
  },

  getListAvailablePrepayment(params) {
    return axios.get(`${baseUrl}/financePrepayment/listAvailablePrepayment?${utils.exchangeParams(params)}`);
  },
  // 新建收款单/新增收款明细-查询销售订单
  getFinanceProceedsListOrder(params) {
    return axios.get(`${baseUrl}/financeProceeds/listOrderDetailToProceeds?${utils.exchangeParams(params)}`);
  },
  getFinanceProceedsListOrderToProceeds(params) {
    return axios.get(`${baseUrl}/financeProceeds/listOrderToProceeds?${utils.exchangeParams(params)}`);
  },
  // 新建收款单/新增收款明细-查询退货单
  getFinanceProceedsListRefundToProceeds(params) {
    return axios.get(`${baseUrl}/financeProceeds/listRefundToProceeds?${utils.exchangeParams(params)}`);
  },

  getFinanceProceedsList(params) {
    return axios.get(`${baseUrl}/financeProceeds/list?${utils.exchangeParams(params)}`);
  },
  submitFinanceProceeds(params) {
    return axios.post(`${baseUrl}/financeProceeds/submit`, utils.exchangeParams(params));
  },
  editFinanceProceeds(params) {
    return axios.post(`${baseUrl}/financeProceeds/edit`, utils.exchangeParams(params));
  },
  addAndSubmitFinanceProceeds(params) {
    return axios.post(`${baseUrl}/financeProceeds/addAndSubmit`, utils.exchangeParams(params));
  },
  addFinanceProceeds(params) {
    return axios.post(`${baseUrl}/financeProceeds/add`, utils.exchangeParams(params));
  },
  getPaidOrder(params) {
    return axios.get(`${baseUrl}/saleOrder/listPaidOrder?${utils.exchangeParams(params)}`);
  },
  getProceedsDetail(params) {
    return axios.get(`${baseUrl}/financeProceeds/info?${utils.exchangeParams(params)}`);
  },
  getProceedsPrintData(params) {
    return axios.get(`${baseUrl}/financeProceeds/print?${utils.exchangeParams(params)}`);
  },
  getFinanceSupplierStatsList(params) {
    return axios.get(`${baseUrl}/financeSupplierStats/list?${utils.exchangeParams(params)}`);
  },
  outputFinanceSupplierStatsList(params) {
    return axios.get(`${baseUrl}/financeSupplierStats/list/download?${utils.exchangeParams(params)}`);
  },
  payableToPaymentList(params) {
    return axios.get(`${baseUrl}/financePayable/infoList?${utils.exchangeParams(params)}`);
  },
  orderToProceedList(params) {
    return axios.get(`${baseUrl}/saleOrder/infoList?${utils.exchangeParams(params)}`);
  },
  getPayableChart(params) {
    return axios.get(`${baseUrl}/financeChart/getPayableChart?${utils.exchangeParams(params)}`);
  },
  getPaymentChart(params) {
    return axios.get(`${baseUrl}/financeChart/getPaymentChart?${utils.exchangeParams(params)}`);
  },
  flowInfoPayment(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundFinancePayment?${utils.exchangeParams(params)}`);
  },
  flowInfoPayable(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundFinancePayable?${utils.exchangeParams(params)}`);
  },
  getInfoAroundRecallPlan(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundRecallPlan?${utils.exchangeParams(params)}`);
  },
  flowInfoInspection(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundPurchaseInspection?${utils.exchangeParams(params)}`);
  },
  flowInfoPurchaseReceipt(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundPurchaseReceipt?${utils.exchangeParams(params)}`);
  },
  flowInfoPurchaseOrder(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundPurchaseOrder?${utils.exchangeParams(params)}`);
  },
  flowInfoPurchasePlan(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundPurchasePlan?${utils.exchangeParams(params)}`);
  },
  // flowInfoPayment(params) {
  //   return axios.get(`${baseUrl}/financeChart/getInfoAroundFinancePayment?${utils.exchangeParams(params)}`);
  // },
  getCostChangeList(params) {
    return axios.get(`${baseUrl}/financePayable/costChange/list?${utils.exchangeParams(params)}`);
  },
  getCostChangeInfo(params) {
    return axios.get(`${baseUrl}/financePayable/costChange/info?${utils.exchangeParams(params)}`);
  },
  getPayableInspectionCode(params) {
    return axios.get(`${baseUrl}/financePayable/listPayableInspectionCode?${utils.exchangeParams(params)}`);
  },
  getPayableRefundCode(params) {
    return axios.get(`${baseUrl}/financePayable/listPayableRefundCode?${utils.exchangeParams(params)}`);
  },

  // 开票管理
  editInvoice(params) {
    return axios.post(`${baseUrl}/financeInvoice/edit`, utils.exchangeParams(params));
  },
  addInvoice(params) {
    return axios.post(`${baseUrl}/financeInvoice/add`, utils.exchangeParams(params));
  },
  finishInvoice(params) {
    return axios.post(`${baseUrl}/financeInvoice/finish`, utils.exchangeParams(params));
  },
  getInvoiceList(params) {
    return axios.get(`${baseUrl}/financeInvoice/list?${utils.exchangeParams(params)}`);
  },
  getInvoiceInfo(params) {
    return axios.get(`${baseUrl}/financeInvoice/info?${utils.exchangeParams(params)}`);
  },
  getOrderToInvoiceList(params) {
    return axios.get(`${baseUrl}/financeInvoice/listOrderToInvoice?${utils.exchangeParams(params)}`);
  },
  getRefundToInvoiceList(params) {
    return axios.get(`${baseUrl}/financeInvoice/listRefundToInvoice?${utils.exchangeParams(params)}`);
  },
  // 预付款记录列表
  getPrePaymentList(params) {
    return axios.get(`${baseUrl}/financePrepayment/list?${utils.exchangeParams(params)}`);
  },
  // 预付款新建
  prePaymentAdd(param) {
    return axios.post(`${baseUrl}/financePrepayment/add`, utils.exchangeParams(param));
  },
  // 预付款详情
  getPrePaymentInfo(params) {
    return axios.get(`${baseUrl}/financePrepayment/info?${utils.exchangeParams(params)}`);
  },
  // 预付款编辑
  prePaymentEdit(params) {
    return axios.post(`${baseUrl}/financePrepayment/edit`, utils.exchangeParams(params));
  },
  // 付款管理列表导出
  downloadFinancePaymentList(params) {
    return axios.get(`${baseUrl}/financePayment/list/download?${utils.exchangeParams(params)}`);
  },
  // 开票管理列表导出
  downloadFinanceInvoiceList(params) {
    return axios.get(`${baseUrl}/financeInvoice/list/download?${utils.exchangeParams(params)}`);
  },
  // 预付管理列表导出
  downloadFinancePrepaymentList(params) {
    return axios.get(`${baseUrl}/financePrepayment/list/download?${utils.exchangeParams(params)}`);
  },
  // 预收和应收管理-接口
  // 1、提交预收单
  submitFinanceDeposit(params) {
    return axios.post(`${baseUrl}/financeDeposit/submit`, params);
  },
  // 查询预收单
  getFinanceDepositList(params) {
    return axios.get(`${baseUrl}/financeDeposit/list?${utils.exchangeParams(params)}`);
  },
  // 查询预收单详情
  getFinanceDepositDetail(params) {
    return axios.get(`${baseUrl}/financeDeposit/detail?${utils.exchangeParams(params)}`);
  },
  // 导出
  financeDepositExport(params) {
    return axios.get(`${baseUrl}/financeDeposit/export?${utils.exchangeParams(params)}`);
  },
  listFinanceDeposit(params) { // 零售日报-零售单据查询接口
    return axios.get(`${baseUrl}/financeProceeds/listFinanceDeposit?${utils.exchangeParams(params)}`);
  },
  listBatchReqByGoodStore(params) { // 票折指定实际商品、批次-- 指定批次
    return axios.get(`${baseUrl}/financePayable/listBatchReqByGoodStore?${utils.exchangeParams(params)}`);
  },

  getProfitRateList(params) { // 商品毛利率列表查询
    return axios.post(`${baseUrl}/profitRate/list`, utils.exchangeParams(params));
  },
  toAddProfitRate(params) { // 新增商品毛利率
    return axios.post(`${baseUrl}/profitRate/add`, params, { headers: {
      'Content-Type': 'application/json',
    }, });
  },
  toSearchGoods(params) { // 搜索商品
    return axios.get(`/v1/erp-base-web/goods/base/list?${utils.exchangeParams(params)}`);
  },
  toSearchStores(params) { // 搜索门店
    return axios.get(`/v1/erp-business-web/profitRate/getStoreInfo?${utils.exchangeParams(params)}`);
  },
  toUpdateProfitStatus(params) { // 启用停用商品毛利率
    return axios.post(`${baseUrl}/profitRate/updateProfitStatus`, utils.exchangeParams(params));
  },
  toUpdateSinglePR(params) { // 修改单个商品毛利率
    return axios.post(`${baseUrl}/profitRate/updateProfitRate`, utils.exchangeParams(params));
  },
  toUpdateBatchPR(params) { // 批量修改商品毛利率
    return axios.post(`${baseUrl}/profitRate/updateBatchProfitRate`, utils.exchangeParams(params));
  },
  toGetHistoryPR(params) { // 查看历史版本商品毛利率
    return axios.get(`/v1/erp-business-web/profitRate/getHistoryProfitRate?${utils.exchangeParams(params)}`);
  },
  getProfitReturnList(params) {
    return axios.post(`${baseUrl}/financeRebate/list`, params);
  },
  downloadProfitReturnList(params) {
    return axios.post(`${baseUrl}/financeRebate/download`, params);
  },
  getSuppliers(params) {
    return axios.get(`${baseUrl}/financePayable/listSupplierInfo?${utils.exchangeParams(params)}`);
  },
  submitReturnProfit(params) {
    return axios.post(`${baseUrl}/financeRebate/add`, params);
  },
  toGetReceipt(params) {
    return axios.get(`${baseUrl}/financeRebate/getPurchaseInfo?${utils.exchangeParams(params)}`);
  },
  getReturnProfitDetail(params) {
    return axios.get(`${baseUrl}/financeRebate/info?${utils.exchangeParams(params)}`);
  },
  getRetProfitAnaList(params) { // 获取返利统计分析列表
    return axios.get(`${baseUrl}/financeRebateStats/list?${utils.exchangeParams(params)}`);
  },
  downloadRetProfitAnaList(params) { // 返利统计列表导出
    return axios.get(`${baseUrl}/financeRebateStats/list/download?${utils.exchangeParams(params)}`);
  },
  getDetailInfo(params) { // 返利统计表查看明细基础信息
    return axios.get(`${baseUrl}/financeRebateStats/detail/infoBase?${utils.exchangeParams(params)}`);
  },
  getBatchList(params) { // 返利统计表中查看批次列表
    return axios.get(`${baseUrl}/financeRebateStats/detail/listBatchReq?${utils.exchangeParams(params)}`);
  },
  getBatchNumList(params) { // 返利统计表中查看批次号列表
    return axios.get(`${baseUrl}/financeRebateStats/detail/listBatchReqCode?${utils.exchangeParams(params)}`);
  },
  doloadBatchList(params) { // 返利统计表导出
    return axios.get(`${baseUrl}/financeRebateStats/detail/downloadBatchReq?${utils.exchangeParams(params)}`);
  },
  getfinancePayableId(params) { // 取消应付单
    return axios.get(`${baseUrl}/financePayable/cancel?${utils.exchangeParams(params)}`);
  },
  revisionListAdd(params) { // 零售日报订正保存
    return axios.post(`${baseUrl}/financeProceeds/revision/add`, params);
  },
  revisionListSubmit(params) { // 零售日报订正提交
    return axios.post(`${baseUrl}/financeProceeds/revision/submit`, utils.exchangeParams(params));
  },
  verifyListSubmit(params) { // 零售日报核验提交
    return axios.post(`${baseUrl}/financeProceeds/verify/submit`, params);
  },
  verifyListAdd(params) { // 零售日报核验保存
    return axios.post(`${baseUrl}/financeProceeds/verify/add`, params);
  },
  revisionDel(params) { // 零售日报订正取消
    return axios.post(`${baseUrl}/financeProceeds/revision/delete`, utils.exchangeParams(params));
  },
  getFinanceProceedsInfo(params) { // 零售日报详情
    return axios.get(`${baseUrl}/financeProceeds/info?${utils.exchangeParams(params)}`);
  },
  revisionRecordDeletion(params) { // 零售日报订正记录删除
    return axios.post(`${baseUrl}/financeProceeds/revision/delete`, params);
  },
  financePayableAbolish(params) { // 应付单废弃按钮
    return axios.get(`${baseUrl}/financePayable/abolish?${utils.exchangeParams(params)}`);
  },
  generateDailyReport(params) { // 生成零售日报
    return axios.get(`${baseUrl}/financeProceeds/generateDailyReport`, params);
  },
  updateDailyReport(params) { // 更新零售日报
    return axios.post(`${baseUrl}/financeProceeds/updateDailyReport`, utils.exchangeParams(params));
  },
  isGeneratedDailyReport(params) { // 是否生成了零售日报
    return axios.get(`${baseUrl}/financeProceeds/isGeneratedDailyReport`, params);
  },
  refundMoney(params) { // 退款
    return axios.post(`${baseUrl}/financeDeposit/refund/submit`, params);
  },
};
